/**
 *  Given a determinate value, returns the corresponding size after canvas scales based on device properties.
 * @param value
 * @param canvas
 */
export function getSizeAfterScaling(value: number, canvas: fabric.Canvas): number {
  const zoom = canvas.getZoom();
  return value / zoom;
}
